export const SEV_PRICING = {
  vatRate: 0.19,
  packages: {
    basis: {
      key: 'basis',
      name: 'Basis',
      monthlyNetPerUnit: 25,
      recommended: false,
      features: [
        'Mieteingangskontrolle und Mahnwesen',
        'Zahlungsverkehr ueber ein Mietkonto',
        'Kommunikation mit Mietern und Dienstleistern',
        'Online-Eigentuemerportal',
      ],
    },
    komfort: {
      key: 'komfort',
      name: 'Komfort',
      monthlyNetPerUnit: 35,
      recommended: true,
      features: [
        'Alles aus Basis',
        'Jaehrliche Betriebskostenabrechnung',
        'Mietanpassung inkl. Index- und Staffelpflege',
        'Einmal jaehrlich Objektkontrolle',
        'Koordination von Instandhaltung bis zur Bagatellgrenze',
        'Bevorzugte Reaktionszeit',
      ],
    },
  },
  parkingNetPerMonth: 4,
  onboardingNetPerUnit: 50,
  referralHints: {
    neuvermietung: '1x Nettokaltmiete',
    modernisierung: '3-5 % der Netto-Baukosten',
    sonderaufwand: '75-95 EUR / Stunde',
    uebergabe: '75 EUR pauschal',
  },
  discounts: [
    { minUnits: 25, type: 'request' },
    { minUnits: 10, type: 'percent', value: 15 },
    { minUnits: 5, type: 'percent', value: 10 },
  ],
};

export const formatCurrencyDE = (value) => {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
};

export const getDiscount = (units) => {
  if (units >= 25) {
    return { type: 'request', label: 'Auf Anfrage / individuelles Angebot' };
  }
  if (units >= 10) {
    return { type: 'percent', value: 15, label: '-15 %' };
  }
  if (units >= 5) {
    return { type: 'percent', value: 10, label: '-10 %' };
  }
  return { type: 'percent', value: 0, label: '0 %' };
};
